import { css } from '@emotion/css';

export const applicationPageCx = css`
  display: flex;
  align-items: center;
  background: var(--colors-neutrals-20);

  > * {
    max-width: 34.375rem;
    width: 100%;
  }

  > header {
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const applicationPageContentCx = (step: number) => css`
  height: 100%;
  max-height: 100%;

  .step {
    background-color: ${step === 3 ? 'var(--colors-primary-30)' : 'white'};
    z-index: 1;
  }

  form {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;

    overflow-y: auto;

    background-color: #f5f5f5;

    .primary-phone-number-container {
      display: flex;
      align-items: center;
      margin-bottom: 2rem;
      gap: 16px;

      .field-group {
        width: 100%;
      }

      .verified-btn {
        padding: 0.675rem;
        width: 200px;
        border-width: 2px;

        .check-icon {
          margin-right: 0.5rem;
        }
      }
    }

    .application-card {
      > .field-group:not(:last-of-type) {
        margin-bottom: 2rem;
      }
    }

    .field-group {
      scroll-margin-top: calc(var(--header-height) + 1rem);
    }

    .row-field {
      display: flex;
      .field-group {
        &:not(:last-child) {
          margin-right: 1rem;
        }
        flex: 1;
      }
    }
  }
`;
